import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-input" }
const _hoisted_2 = ["id", "data-scope", "placeholder"]

import hotkeys from "hotkeys-js";

  import { onMounted, onUnmounted, ref, watch } from "vue";
  import { BaseIcon, CrossIcon } from "@/components/icons";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomHotKeyInput',
  props: /*#__PURE__*/_mergeModels({
    scope: {},
    inputClass: { default: null },
    inputId: { default: null },
    withClear: { type: Boolean, default: false },
    placeholder: { default: "Enter the key" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

  const props = __props;

  const modelValue = _useModel<string[] | string | null>(__props, "modelValue");

  const inputRef = ref<HTMLInputElement>();

  watch(modelValue, () => {
    updateInput();
  });

  onMounted(() => {
    hotkeys("*", { scope: props.scope, element: inputRef.value }, callback);
    updateInput();
  });

  onUnmounted(() => {
    hotkeys.unbind("*", props.scope, callback);
  });

  const clearModelValue = () => {
    modelValue.value = null;
  };

  const updateInput = () => {
    let values = modelValue.value ?? "";
    if (Array.isArray(values)) {
      values = values.join(" + ");
    }
    inputRef.value?.setAttribute("value", values);
  };

  const callback = (e: KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const pressedKeyString = hotkeys.getPressedKeyString();
    const ignoredKeys = ["del", "backspace", "tab"];

    if (ignoredKeys.some((key) => hotkeys.getPressedKeyString().includes(key))) {
      return;
    }

    let value = pressedKeyString.map((item) => item.toUpperCase()).join(" + ");

    inputRef.value?.setAttribute("value", value);
    modelValue.value = pressedKeyString || [];
    return false;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: props.inputId,
      type: "text",
      class: _normalizeClass(props.inputClass),
      "data-scope": _ctx.scope,
      placeholder: _ctx.placeholder,
      ref_key: "inputRef",
      ref: inputRef
    }, null, 10, _hoisted_2),
    (_ctx.withClear)
      ? (_openBlock(), _createBlock(_unref(BaseIcon), {
          key: 0,
          class: "input-clear",
          "icon-name": "cross",
          width: "14",
          height: "14",
          viewBox: "0 0 28.945 28.945",
          onClick: clearModelValue
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CrossIcon))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})